import cookie from 'cookie';

export default function getCookieValue(value) {
  const availableCookies = cookie.parse(document.cookie);
  return availableCookies[value] || '';
}
